module.exports = __webpack_public_path__ + "img/map_placeholder.6c28bd19.png";